import React from "react";
import { StateManagerContext } from "./StateManagerContext";
import { Carousel, CarouselProps } from "./Carousel";
import { MessageConfigData } from "../Shared/Party/PartyConfigData";
import { getChat, LiveMessageFeed, LiveMessageFeedProps, renderMessageFeedPanel } from "./LiveMessageFeed";
import { UIConfigContext } from "./UIConfigContext";

export type UserMessageDisplayProps = {
    width: number;
    height: number;
    absolute: boolean;
    top?: number,
    left?: number,
    background: string;
    fontBase: number;
    showSignIn(): void;
    showProfileDisplay(nickname : string) : void;
}

export const UserMessageDisplay = (): React.JSX.Element => {

    const stateManager = React.useContext(StateManagerContext);
    const uiConfig = React.useContext(UIConfigContext);
    const height = uiConfig.height - uiConfig.titleHeight;
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const messageList = stateManager.userMessages().getForDisplay();

    const notifyOnCarouselAction = (index: number) => {
        setSelectedIndex(index);

    }
    const carouselProps = React.useRef<CarouselProps>((() => {
        const ret : CarouselProps = {
            display: 1,
            width: uiConfig.width,
            height: 200,
            scrollButtonWidth: 50,
            idPrefix: 'UserMessageDisplayCarousel',
            userControlled: true,
            notifyOnClick: notifyOnCarouselAction,
            panels: messageList.length > 0 ? messageList.map((row, index) => {
                return renderMessageFeedPanel(row.message, uiConfig.contolBackground, uiConfig.fontBase, stateManager.user().fanbox.id, index + 1000, (_nickname : string)=> {});
            }) : [<span style={{fontFamily : 'roboto', fontWeight : 500, fontSize : (2 * uiConfig.fontBase) + 'px'}}>You have not posted any messages yet</span>]
         };
         return ret;
        })() 
    );

    const messageComponents = messageList.length > 0 ? messageList[selectedIndex].message.replies.map((reply, index) => {
        return renderMessageFeedPanel(reply, uiConfig.contolBackground, uiConfig.fontBase, stateManager.user().fanbox.id, index + 10000, uiConfig.showEventOverlay);
    }) : (messageList.length > 0 ? <span style={{fontFamily : 'roboto', fontWeight : 500, fontSize : (1.5 * uiConfig.fontBase) + 'px'}}>You have not posted any messages yet</span> : <div></div>);



    return <div style={{
        display: 'flex',
        flexDirection: 'column',
        minWidth: uiConfig.width + 'px',
        width: uiConfig.width + 'px',
        maxWidth: uiConfig.width + 'px',
        height: height + 'px',
        maxHeight: height + 'px',
        minHeight: height + 'px',
        position:  'relative',

        backgroundColor: uiConfig.contolBackground

    }}>
        <Carousel {...carouselProps.current} />
        <div style={{
            width: uiConfig.width + 'px',
            minWidth: uiConfig.width + 'px',
            maxWidth: uiConfig.width + 'px',
            height: (height - 200) + 'px',
            maxHeight: (height - 200) + 'px',
            minHeight: (height - 200) + 'px',
            overflow: 'auto'
        }}>
            <div style={{
                width: uiConfig.width + 'px',
                minWidth: uiConfig.width + 'px',
                maxWidth: uiConfig.width + 'px'
            }}>
                {messageComponents}
            </div>
        </div>
    </div>

}